// extracted by mini-css-extract-plugin
module.exports = {"hidden":"backgroundArea_hidden__J2amm","textEmphasis":"backgroundArea_textEmphasis__9HRmF","bg":"backgroundArea_bg__ZyvPE"};